'use strict';

module.exports = require('./Checkbox');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.0.1@rc-checkbox/lib/index.js
 ** module id = 186
 ** module chunks = 0 1
 **/